import {Component, OnInit} from '@angular/core';
import * as html2canvas from "html2canvas";
import {FacebookService, InitParams} from "ngx-facebook";
import * as Canvas2Image from "canvas2image";
import {Router, NavigationEnd} from "@angular/router";


declare let ga: Function;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit  {
  title = 'app';

  arrayInizio =["Palermo, professore ipovedente rimprovera alunna e il padre lo picchia: sospetta emorragia cerebrale.",
    "L'Italia, se vuole sopravvivere, non deve restare nella Nato, con l'euro e nell'Ue.",
    "Orbene, sono fiero di parlare la veterolingua italica, in rivendicata antitesi con la neolingua globalista a vocazione anglofona e mercatistica.",
    "Di Maio: “Parlo all’intero Pd, non per spaccarlo”.",
    "Da ieri, trovate in molti cinematografi d'Italia una pregevolissima pellicola sulla vita e sul pensiero del giovane Carlo Marx.",
    "Non mi sono mai candidato. Né mi sono mai recato col cappello in mano da politici e da politicanti.",
    "Il panconsumista erotico a immaginario ipersessualizzato deve, in pari tempo, essere libero dalla rigida distinzione di sesso e di genere, oltre che dal vincolo etico di tipo familiare.",
    "L'aristocrazia finanziaria apolide e turbocapitalistica chiama progresso i suoi materialissimi interessi. ",
    "Tremate, turbocapitalisti apolidi e talassici abitatori della società liquida a postmodernizzazione avanzata!",
    "Gli sciocchi che elogiavano Macron contro la Le Pen e contro l'eterno fascismo ora, a Bardonecchia, si pentono?",
    "Inaugurato a Torino un asilo senza differenziazioni di genere. In pratica, non vi saranno più bambini e bambine: ma solo enti neutri, indifferenziati e senza identità.",
    "Hitler è tornato. Senza svastica e senza baffetti. È in giacca e cravatta. Parla inglese e ripete che 'ce lo chiede l'Europa'.",
    "La società alla deriva. Il turbonichilismo avanza galoppante, alambicco che ogni essente e ogni valore trasmuta nel nulla.",
    "In una scuola superiore di Alessandria un gruppo di studenti ha legato alla sedia la professoressa e l'ha presa a calci.",
    "Ma v'è qualcuno di tanto stolido da credere plausibile che la Russia abbia avvelenato la spia inglese?",
    "La disfatta delle sinistre atlantiste, euroserve e nemiche dei lavoratori è da accogliersi con giubilante euforia.",
    "'Femminicidio': ecco un altro lemma della neolingua capitalistica, che mira a occultare la lotta di classe sotto la vernice della lotta tra i sessi.",
    "Ringraziamo, tra le altre cose, la signora Paola Cortellesi per essersi prestata, col suo monologo politicamente corretto, al pensiero unico dominante che vuole ortopedizzarci tutti in nome della società livellata turbocapitalistica, superclassista e femminilizzata."];

  arrayMedio=["Come ebbe a dire il compianto Costanzo Preve, 'il messaggio è irricevibile, quando il destinatario è irriformabile'.",
    "La cosa sconcertante è la solitudine dei lavoratori, classe irrappresentata ormai dalle sinistre market-friendly, traditrici di Marx e di Gramsci.",
    "La baldanzosa rinascenza col Plato e l'Aristotile sarà palingenetica per l'umanità tutta!",
    "Una manica di sciocchi prezzolati e ipocriti, vegani e demofobi, che difendono gli agnelli (gli Agnelli prima!) e i capretti e intanto mandano al macello i lavoratori.",
    "Lor signori del mondialismo lo chiamano 'libero mercato'. È libero cannibalismo.",
    "La chiamano globalizzazione. È 'glebalizzazione', produzione di miseria e servitù su scala planetaria.",
    "La barbarie avanza rapida. Il nulla, come nel noto libro 'La storia infinita', sta divorando ogni residuo frammento della nostra civiltà.",
    "Urge scrivere un caustico libello sul modello del 'Misogallo' dell'amato Alfieri.",
    "Goethe e l’estrazione del plusvalore, Beethoven e il sistema del credito, Kant e lo sfruttamento del lavoro. Nell’ordine del nuovo turbocapitalismo post-borghese e post-proletario, la contraddizione si risolve a beneficio della nuda logica del valore di scambio.",
    "Senza alcuna tema, dico Nuova York e ananasso, corriera e cinematografo.",
    "Deve, al contrario, figurare come un ente neutro e planetariamente indifferenziato, puro supporto impersonale e gender-fluid per le pratiche “onnigame” del plusgodimento neolibertino aprospettico e scevro di differimenti, innalzato a sola Legge nel tempo della morte di Dio e dell’annessa beatificazione del libero mercato deregolamentato.",
    "E mandò a morte il Cristo in croce. V’è di che riflettere, credo. Occorre, anche in questo caso, provare a pensare altrimenti: secondo le logiche sempre più avversate dell’obstinate contra.",
    "La neolingua li chiama 'governi tecnici'. Sono colpi di stato finanziari.",
    "Io la chiamo omologazione al pensiero comune mondialista e iperconsumistico, ma non creda che con la rivoluzione cambi qualcosa.",
    "L'intervento aveva necessità di un interlocutore moralmente più onesto e proteso all'ascolto. Forse ad un certo punto la discussione aveva perso ogni connotato e divenuta un mero esercizio canoro.",
    "Ormai lo sanno anche i bambini che si tratta dell'ennesima foglia di fico per giustificare i bombardamenti umanitari dell'imperialismo etico made in USA.",
    "Ora dovranno scegliere un nuovo cavallo da cavalcare, nuovi servi che attuino i loro desiderata. State pronti.",
    "Insomma, se non sapessimo, grazie ai generosi pedagoghi del mondialismo, chi sono i buoni e chi i cattivi saremmo quasi indotti a pensare che potenti occidentali e terroristi orientali giochino con la maglia della stessa squadra."]

  arrayFine =["Alla Leopolda solo i signori della finanza sradicante, con tanto di cordoni di polizia fuori.",
    "La misura è colma. La società della trasgressione permanente.",
    "Per quel che mi riguarda, lo penso e non smetterò di pensarlo e di dirlo.",
    "E' una forma di resistenza culturale alla barbarie che avanza.",
    "Ho sempre pensato in autonomia, nel pieno della sovranità mentale. E continuo a farlo. Obstinate contra.",
    "È un'occasione unica: un governo di non allineati, senza PD e Forza Italia.",
    "Deve godere senza norme, senza pensare ad altro che a godere, ossia a consumare merci erotiche liberalizzate.",
    "Così senza fatica il mio ventre si riempie.' 'Ma se ti vien voglia di andartene , è permesso?' 'Ah, questo no', rispose. 'Goditi quello che vanti, cane. Neanche un regno vorrei, se non libero'.",
    "E così ci induce a elogiarli, anziché contestarli operativamente.",
    "È deportazione voluta dalla Destra liberista del Danaro e difesa dalla Sinistra libertaria del Costume.",
    "Forse la summenzionata questione dovrebbe indurci a riflettere sulla così semplice e così in voga equazione di identità tra la verità e ciò che la “maggioranza diretta” decreta essere tale. Forse la verità non si mette ai voti. Ce lo insegna la vicenda di Gesù. E, prima ancora, quella di Socrate.",
    "Hanno appoggiato l'uomo prodotto in vitro dai signori apolidi del mondialismo.",
    "O, meglio, non v’è altro se non il vuoto nichilistico di un mercato che ha ormai colonizzato il materiale e l’immateriale.",
    "Contro gli euroinomani del 'ci vuole più Europa'.",
    "La società del padre assente e della trasgressione permanente a liberalizzazione integrale dei consumi e dei costumi.",
    "Il mondialista odia le patrie, ché vuole vedere ovunque il medesimo, il piano liscio del mercato globale senza identità, culture e radici, con schiavi interscambiabili. E voi da che parte state?",
    "Ancora vi bevete queste menzogne evidenti, dopo le famigerate armi di distruzione di massa inesistenti, e mille altre escogitazioni pensate ad hoc per muovere guerra? Sveglia!",
    "Parameci privi di dignità, per i quali l'inferno dantesco sarebbe ancor poco."];


  quote ='';

  constructor(private fb: FacebookService ) {
    ga('send', 'pageview');
    let initParams: InitParams = {
      appId: '423092928141332',
      xfbml: true,
      version: 'v2.8'
    };

    fb.init(initParams);
  }


  generateQuote(){
    this.quote=
      this.arrayInizio[this.getRandomInt(0,this.arrayInizio.length-1)] +
      this.arrayMedio[this.getRandomInt(0,this.arrayMedio.length-1)]+
      this.arrayFine[this.getRandomInt(0,this.arrayFine.length-1)];
  }

  ngOnInit() {
      this.generateQuote();
  }
  /**
   * Returns a random integer between min (inclusive) and max (inclusive)
   * Using Math.round() will give you a non-uniform distribution!
   */
  getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
  }
  captureIt(){
    let self =this;
    html2canvas(document.querySelector("#capture")).then(canvas => {
      Canvas2Image.save

    });
  }


}



// WEBPACK FOOTER //
// ./src/app/app.component.ts